import { Component, OnInit, Output, EventEmitter } from '@angular/core';
declare var $;

@Component({
  selector: 'app-message1-modal',
  templateUrl: './message1-modal.component.html',
  styleUrls: ['./message1-modal.component.scss']
})
export class Message1ModalComponent implements OnInit {

  public title: string = '';
  public message: string = ''
  public callback: string;
  @Output() public goCallback: EventEmitter<string> = new EventEmitter;
  constructor() { }

  ngOnInit() {
  }

  open(data) {
    this.fill(data);
    $('#message1Modal').modal('show');
  }

  accept() {
    this.close();
    if (this.callback) {
      this.goCallback.emit(this.callback);
    }
  }

  close() {
    $('#message1Modal').modal('hide');
  }

  fill(data) {
    console.log('fill-data ', data);
    this.title = data.title;
    this.message = data.message;

    if (data.callback) {
      this.callback = data.callback;
    }

  }

}


// WEBPACK FOOTER //
// ./src/app/components/tools/modals/message1-modal/message1-modal.component.ts